import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const courseArrange = {
    teacherWorkload: {
        queryList: config => createAPI('/courseArrange/teacherWorkload/queryList', 'post', config),
        initCombo: config => createAPI('/courseArrange/teacherWorkload/initCombo', 'post', config),
        exportExcel: config => createAPI('/courseArrange/teacherWorkload/exportExcel', 'post', config),
        print: config => createAPI('/courseArrange/teacherWorkload/print', 'post', config),
        queryTeaWorkInfo: config => createAPI('/courseArrange/teacherWorkload/queryTeaWorkInfo', 'post', config),
        skzcOption: config => createAPI('/courseArrange/teacherWorkload/skzcOption', 'post', config),
        teacherOption: config => createAPI('/courseArrange/teacherWorkload/teacherOption', 'post', config),
        queryAdjustInfo: config => createAPI('/courseArrange/teacherWorkload/queryTeaWorkInfo', 'post', config),
        exportTeacherWork: config => createAPI('/courseArrange/teacherWorkload/exportTeacherWork', 'post', config),
    },
	teacherFee: {
	    queryList: config => createAPI('/courseArrange/teacherFee/queryList', 'post', config),
	    exportExcel: config => createAPI('/courseArrange/teacherFee/exportExcel', 'post', config),
	    exportTeacherFee: config => createAPI('/courseArrange/teacherFee/exportTeacherFee', 'post', config),
	}
};


export default courseArrange;



// WEBPACK FOOTER //
// ./src/api/modules/courseArrange.js